
import PropTypes from 'prop-types';
import { Stack, Button, Text, Group, Box } from '@mantine/core';
import bedShapeOne from '../images/ui_buttons/bed_shape_1_button.png';
import bedShapeTwo from '../images/ui_buttons/bed_shape_2_button.png';
import bedShapeThree from '../images/ui_buttons/bed_shape_3_button.png';
import bedShapeFour from '../images/ui_buttons/bed_shape_4_button.png';
import bedShapeFive from '../images/ui_buttons/bed_shape_5_button.png';
import { colors, fontSize } from '../constants';

const { white } = colors;

const GardenBedButtonsMobile = ({
	selectedShape,
	selectedBedSize,
	onShapeClick,
	onSizeClick,
	showShapes,
	showSizes
}) => {
	const shapeButtons = [
		{ id: 'bed_shape_1', image: bedShapeOne, alt: 'Bed Shape 1' },
		{ id: 'bed_shape_2', image: bedShapeTwo, alt: 'Bed Shape 2' },
		{ id: 'bed_shape_3', image: bedShapeThree, alt: 'Bed Shape 3' },
		{ id: 'bed_shape_4', image: bedShapeFour, alt: 'Bed Shape 4' },
		{ id: 'bed_shape_5', image: bedShapeFive, alt: 'Bed Shape 5' }
	];

	const sizeOptions = [
		{ id: 12, label: "12' x 6'" },
		{ id: 15, label: "15' x 8'" },
		{ id: 18, label: "18' x 9'" }
	];

	return (
		<Box style={{ width: '100%', height: '100%' }}>
			{showShapes && (
				<Stack gap="0.5vh" style={{ height: '100%' }}>
					<Text style={{
						color: white,
						fontSize: fontSize.xxl,
						fontWeight: 'bold',
						textAlign: 'center',
            paddingTop: '1.5vh',
						marginBottom: '0vh'
					}}>
						Bed Shape
					</Text>
					
					<Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Group gap="0.25vh" style={{ width: '100%', justifyContent: 'center' }}>
							<Button
								variant="filled"
								onClick={() => onShapeClick('bed_shape_1')}
								styles={{
									root: {
										backgroundColor: selectedShape === 'bed_shape_1' ? colors.selectedLightGrey : colors.buttonColor,
										border: selectedShape === 'bed_shape_1' ? '0.25vh solid #475a46' : '0.25vh solid #666',
										borderRadius: '1.25vh',
										height: '12vw',
										width: '12vw',
										minHeight: '7.5vh',
										minWidth: '7.5vh',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: 0,
                    margin: 0
									}
								}}
							>
								<img src={bedShapeOne} alt='Bed Shape 1' style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
							</Button>
							
							<Button
								variant="filled"
								onClick={() => onShapeClick('bed_shape_2')}
								styles={{
									root: {
										backgroundColor: selectedShape === 'bed_shape_2' ? colors.selectedLightGrey : colors.buttonColor,
										border: selectedShape === 'bed_shape_2' ? '0.25vh solid #475a46' : '0.25vh solid #666',
										borderRadius: '1.25vh',
										height: '12vw',
										width: '12vw',
										minHeight: '7.5vh',
										minWidth: '7.5vh',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: 0,
                    margin: 0
									}
								}}
							>
								<img src={bedShapeTwo} alt='Bed Shape 2' style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
							</Button>
							
							<Button
								variant="filled"
								onClick={() => onShapeClick('bed_shape_3')}
								styles={{
									root: {
										backgroundColor: selectedShape === 'bed_shape_3' ? colors.selectedLightGrey : colors.buttonColor,
										border: selectedShape === 'bed_shape_3' ? '0.25vh solid #475a46' : '0.25vh solid #666',
										borderRadius: '1.25vh',
										height: '12vw',
										width: '12vw',
										minHeight: '7.5vh',
										minWidth: '7.5vh',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: 0,
                    margin: 0
									}
								}}
							>
								<img src={bedShapeThree} alt='Bed Shape 3' style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
							</Button>
							
							<Button
								variant="filled"
								onClick={() => onShapeClick('bed_shape_4')}
								styles={{
									root: {
										backgroundColor: selectedShape === 'bed_shape_4' ? colors.selectedLightGrey : colors.buttonColor,
										border: selectedShape === 'bed_shape_4' ? '0.25vh solid #475a46' : '0.25vh solid #666',
										borderRadius: '1.25vh',
										height: '12vw',
										width: '12vw',
										minHeight: '7.5vh',
										minWidth: '7.5vh',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: 0,
                    margin: 0
									}
								}}
							>
								<img src={bedShapeFour} alt='Bed Shape 4' style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
							</Button>
							
							<Button
								variant="filled"
								onClick={() => onShapeClick('bed_shape_5')}
								styles={{
									root: {
										backgroundColor: selectedShape === 'bed_shape_5' ? colors.selectedLightGrey : colors.buttonColor,
										border: selectedShape === 'bed_shape_5' ? '0.25vh solid #475a46' : '0.25vh solid #666',
										borderRadius: '1.25vh',
										height: '12vw',
										width: '12vw',
										minHeight: '7.5vh',
										minWidth: '7.5vh',
										padding: 0,
                    margin: 0
									}
								}}
							>
								<img src={bedShapeFive} alt='Bed Shape 5' style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
							</Button>
						</Group>
					</Box>
				</Stack>
			)}

			{showSizes && (
				<Stack gap="1.875vh" style={{ height: '100%' }}>
					<Text style={{
						color: white,
						fontSize: fontSize.xl,
						fontWeight: 'bold',
						textAlign: 'center',
						paddingTop: '1.5vh',
						marginBottom: '0vh'
					}}>
						Bed Size
					</Text>
					
					<Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Group gap="0.25vh" style={{ width: '100%', justifyContent: 'center' }}>
							{sizeOptions.map((size) => (
								<Button
									key={size.id}
									variant="filled"
									onClick={() => onSizeClick(size.id)}
									styles={{
										root: {
											backgroundColor: selectedBedSize === size.id ? colors.green : colors.buttonColor,
											//border: selectedBedSize === size.id ? '0.25vh solid #475a46' : '0.25vh solid #666',
											borderRadius: '1.25vh',
											height: '9.5vh',
											width: '22vw',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}
									}}
								>
									<Text style={{
										fontSize: fontSize.lg,
										fontWeight: 'bold',
										color: colors.white
									}}>
										{size.label}
									</Text>
								</Button>
							))}
						</Group>
					</Box>
				</Stack>
			)}
		</Box>
	);
};

GardenBedButtonsMobile.propTypes = {
	selectedShape: PropTypes.string,
	selectedBedSize: PropTypes.number,
	onShapeClick: PropTypes.func.isRequired,
	onSizeClick: PropTypes.func.isRequired,
	showShapes: PropTypes.bool.isRequired,
	showSizes: PropTypes.bool.isRequired
};

export default GardenBedButtonsMobile;
